import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Store, BadgeCheck, MapPin } from "lucide-react";
import api from "@/lib/api";

export default function PublicSellers() {
  const [sellers, setSellers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "Sellers — Suffle Online";
    api.get("/marketplace/public/sellers").then((r) => setSellers(r.data.sellers || [])).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="public-sellers">
      <h1 className="text-3xl font-bold text-slate-900">Verified Sellers</h1>
      <p className="mt-1 text-sm text-slate-500">Discover approved sellers on the Suffle marketplace.</p>

      {loading ? (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">{[0, 1, 2, 3, 4, 5].map((i) => <div key={i} className="h-28 animate-pulse rounded-2xl bg-white/70" />)}</div>
      ) : sellers.length === 0 ? (
        <p className="mt-10 rounded-xl border border-dashed border-slate-300 p-10 text-center text-sm text-slate-500" data-testid="sellers-empty">No sellers to show yet. Please check back soon.</p>
      ) : (
        <div className="mt-6 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {sellers.map((s) => (
            <Link key={s.slug} to={`/${s.slug}`} data-testid={`seller-card-${s.slug}`} className="flex items-center gap-3 rounded-2xl border border-slate-200 bg-white p-4 transition hover:shadow-md">
              <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-slate-100">{s.logo ? <img src={s.logo} alt="" className="h-full w-full object-cover" /> : <Store className="h-6 w-6 text-slate-300" />}</span>
              <div className="min-w-0">
                <p className="flex min-w-0 items-center gap-1 font-semibold text-slate-900"><span className="truncate" title={s.name}>{s.name}</span>{s.verified && <BadgeCheck className="h-4 w-4 shrink-0 text-emerald-500" />}</p>
                {s.location && <p className="flex min-w-0 items-center gap-1 text-xs text-slate-400" title={s.location}><MapPin className="h-3 w-3 shrink-0" /><span className="truncate">{s.location}</span></p>}
                {typeof s.product_count === "number" && <p className="text-xs text-slate-400">{s.product_count} products</p>}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
